import Popper from "popper.js";

export const deletePopperElement = (popperElement) => {
  popperElement.destroy();
};

export const createBottomPopperElement = (triggerElement, elementToPosition) => {
  return new Popper(triggerElement, elementToPosition, {
    placement: "bottom-start", // Default position ie aligned to the bottom left of the trigger element
    modifiers: {
      flip: {
        enabled: true, // Allow to automatically re-position the element if space is missing
        behavior: ["bottom-start", "bottom-end"], // Allowed positions
      },
      offset: {
        offset: "0, 4",
      },
    },
  });
};
